import { c as _c } from "react/compiler-runtime";
import { graphql, readFragment } from "@opensea/graphql";
import { FloorPriceSparkLineChart } from "@/components/collection/FloorPriceSparkLineChart/FloorPriceSparkLineChart";
import { FloorPriceSparkLineChartFragment } from "@/components/collection/FloorPriceSparkLineChart/FloorPriceSparkLineChart.fragment";
import { useStatsSparklineChartClassName } from "../use-stats-sparkline-chart-classname";
export const StatsTableRowSparkLineChartFragment = graphql(`
    fragment StatsTableRowSparkLineChart on Collection {
      ...FloorPriceSparkLineChart
    }
  `, [FloorPriceSparkLineChartFragment]);
export function StatsTableRowSparkLineChart(t0) {
  const $ = _c(5);
  const {
    collection: key
  } = t0;
  let t1;
  if ($[0] !== key) {
    t1 = readFragment(StatsTableRowSparkLineChartFragment, key);
    $[0] = key;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const collection = t1;
  const className = useStatsSparklineChartClassName();
  let t2;
  if ($[2] !== className || $[3] !== collection) {
    t2 = <FloorPriceSparkLineChart className={className} collection={collection} />;
    $[2] = className;
    $[3] = collection;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}